import { Observable, ObservableInput } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IApiErrorParams, ApiErrorCode } from '../apiError.interface';
import { handleApiError } from '../_helpers/handleApiError';

export const catchApiError = <T, O extends ObservableInput<unknown>>(selector: (err: IApiErrorParams) => O) => (source: Observable<T>) => {
  return source.pipe(
    catchError((error) => {
      const handledError = handleApiError(error);

      if (handledError) {
        return selector(handledError);
      }

      return selector({
        status: 0,
        errorCode: ApiErrorCode.UnknownError,
        description: error instanceof Error ? error.message : String(error),
      });
    }),
  );
};
